/** Sur un PDA, le premier écran après le démarrage ou la connexion est le Mode Stock, pas le tableau de bord. */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { useAuth } from '@/contexts/AuthContext';
import { useHandheldDevice } from '@/hooks/useCompactLayout';
import { useFeatureToggles } from '@/hooks/useFeatureToggles';
import { useEffectiveTenantId } from '@/hooks/useTenant';

// Une fois par chargement et par compte : le menu « Accueil » reste accessible ensuite.
let landedUserId: string | null = null;

type StockModeLandingProps = {
  children: ReactNode;
};

export function StockModeLanding({ children }: StockModeLandingProps) {
  const { user } = useAuth();
  const narrow = useHandheldDevice();
  const tenantId = useEffectiveTenantId();
  const { isFeatureEnabled, isFetched } = useFeatureToggles();
  if (!narrow || !user || !tenantId || landedUserId === user.id) return <>{children}</>;
  if (!isFetched) return <LoadingSpinner />;
  landedUserId = user.id;
  const landing = isFeatureEnabled('mode_stock') && isFeatureEnabled('mode_stock_demarrage');
  return landing ? <Navigate to="/mode-stock" replace /> : <>{children}</>;
}
